module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('h3', [_vm._v("订单信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票状态:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商信息:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentCode) + " " + _vm._s(_vm.OrderData.AgentName) + " " + _vm._s(_vm.OrderData.AgentAddress) + " " + _vm._s(_vm.OrderData.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请开票时间:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属业务经理:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("订单1")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属项目:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所选套餐:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.ProductList != ''),
      expression: "OrderData.ProductList!=''"
    }],
    staticClass: "w100",
    attrs: {
      "label": "商品:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.OrderData.ProductList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "套餐数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "超出部分"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "单价"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售总价"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.PreOrderPrice) + "元 ")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("开票信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请开票类型:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "统一社会代码:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行及账号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户许可证:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "一般纳税人资质:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('h3', [_vm._v("收货信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderStatusName))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("寄件信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.OrderData.PayMode),
      callback: function($$v) {
        _vm.$set(_vm.OrderData, "PayMode", $$v)
      },
      expression: "OrderData.PayMode"
    }
  }, _vm._l((_vm.PayList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "快递或物流名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.OrderData.LogisticsId),
      callback: function($$v) {
        _vm.$set(_vm.OrderData, "LogisticsId", $$v)
      },
      expression: "OrderData.LogisticsId"
    }
  }, _vm._l((_vm.Logistics), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": _vm.showMailDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.OrderData.Remark),
      callback: function($$v) {
        _vm.$set(_vm.OrderData, "Remark", $$v)
      },
      expression: "OrderData.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.submitLoding
    },
    on: {
      "click": _vm.submitpass
    }
  }, [_vm._v("确认开票")])], 1)], 1)], 1), _vm._v(" "), _c('mailManagerDialog', {
    ref: "ref_mailManagerDialog",
    on: {
      "addMailCallback": _vm.addMailCallback,
      "deleteMailCallBack": _vm.deleteMailCallBack
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4746649a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/components/orderInvoice/index.vue
// module id = 1471
// module chunks = 1